export default class Settings
{
  constructor(email, phone, facebook, instagram, address, latitude, longitude) 
  {
    this.email = email;
    this.phone = phone;
    this.facebook = facebook;
    this.instagram = instagram;
    this.address = address;
    this.latitude = latitude;
    this.longitude = longitude;
  }    

  isValid()
  {
    return this.email && this.phone && this.facebook && this.instagram && this.address && this.latitude && this.longitude;
  }
}